import { render, staticRenderFns } from "./IsLatestWarning.vue?vue&type=template&id=5fd81af2"
import script from "./IsLatestWarning.vue?vue&type=script&lang=js"
export * from "./IsLatestWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports